import ToolGroup from '~/components/toolbar/shared/ToolGroup';
import BoxZoomTool from '~/components/toolbar/tools/BoxZoomTool';
import ContouringTools from '~/components/toolbar/tools/ContouringTools';
import IntensityTool from '~/components/toolbar/tools/IntensityTool';
import MeasurementTool from '~/components/toolbar/tools/MeasurementTool';
import DifferenceOverlayTool from '~/components/toolbar/tools/DifferenceOverlayTool';
import IsolateTool from '~/components/toolbar/tools/IsolateTool';
import AdjacentSliceGhostsTool from '~/components/toolbar/tools/AdjacentSliceGhostsTool';
import WindowingHistogramTool from '~/components/toolbar/tools/WindowingHistogramTool';
import SeriesOverviewTool from '~/components/toolbar/tools/SeriesOverviewTool';
import PanTool from '~/components/toolbar/tools/PanTool';
import ResetViewTool from '~/components/toolbar/tools/ResetViewTool';
import RotateViewTool from '~/components/toolbar/tools/RotateViewTool';
import ScreenshotTool from '~/components/toolbar/tools/ScreenshotTool';
import UndoRedoTool from '~/components/toolbar/tools/UndoRedoTool';

export default function ContouringStepTools() {
    return (
        <>
            <PanTool />
            <BoxZoomTool />
            <RotateViewTool />
            <ResetViewTool />
            <WindowingHistogramTool />
            <SeriesOverviewTool />
            <MeasurementTool />
            <IntensityTool />
            <DifferenceOverlayTool />
            <IsolateTool />
            <AdjacentSliceGhostsTool />
            <ScreenshotTool />
            <ContouringTools />
            <ToolGroup>
                <UndoRedoTool />
            </ToolGroup>
        </>
    );
}
